import { AxiosRequestConfig } from "axios"

const getVersion = (): AxiosRequestConfig => ({
  url: '/web-api-version',
  method: 'GET',
})

export { getVersion }
